import { IPD_GET_BED_AVAILABILITY, IPD_LOAD_DATA } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface Response {
    success: boolean;
    data?: DataEntity[] | null;
}
export interface DataEntity {
    id: string;
    name: string;
    room: string;
    updatedAt: string;
}

export default (): Promise<Response> => {
    return fetchWithRefresh(IPD_GET_BED_AVAILABILITY, {
        method: 'GET',
        headers: {
            'Content-type': 'application/json',
        },
    }).then((res) => res.json());
};
